import type {PropsWithClassName} from 'types/util'
import {cn} from 'utils'

function SpinnerComp({className}: PropsWithClassName) {
  return (
    <div
      className={cn(
        'w-[70px] h-[70px] bg-riverBed rounded relative',
        'before:w-[70%] before:h-[70%] before:rounded-full before:bg-white before:opacity-60',
        'before:absolute before:top-[15%] before:left-[15%]',
        'after:w-[70%] after:h-[70%] after:rounded-full after:bg-white after:opacity-60',
        'after:absolute after:top-[15%] after:left-[15%]',
        'before:animate-[spinnerBounce_2s_ease-in-out_infinite]',
        'after:animate-[spinnerBounce_2s_-1s_ease-in-out_infinite]',
        className
      )}
    />
  )
}

interface SpinnerProps extends PropsWithClassName {
  position?: 'absolute' | 'fixed'
  overlay?: boolean
}

export const Spinner = ({
  position = 'absolute',
  overlay,
  className,
}: SpinnerProps) => {
  return (
    <div
      className={cn(
        'flex justify-center items-center',
        position === 'absolute' && 'absolute inset-0',
        position === 'fixed' && 'fixed inset-0',
        overlay && 'bg-white/60',
        overlay ? 'z-overlay' : 'z-growl',
        className
      )}
    >
      <SpinnerComp className='opacity-50' />
    </div>
  )
}
